import ResourcePage from "@/components/ResourcePage";

export default function NotesPage() {
  return (
    <ResourcePage
      resource="notes"
      title="Gespräche"
      subtitle="Dokumentation aller Gespräche mit Kontakten."
      singular="Gespräch"
      newButtonLabel="Neues Gespräch"
      createDialogTitle="Gespräch erfassen"
      editDialogTitle="Gespräch bearbeiten"
      submitButtonLabel="Gespräch speichern"
      emptyDescription="Halte dein erstes Gespräch fest, um zu starten."
      emptyCreateButtonLabel="Gespräch erfassen"
      testidPrefix="notes"
      fields={[
        { name: "title", label: "Titel", type: "text", required: true },
        {
          name: "contact_id",
          label: "Person",
          type: "select",
          optionsFromResource: "contacts",
          optionLabel: (c) => `${c.first_name} ${c.last_name}`,
          placeholder: "Person wählen…",
        },
        {
          name: "company_id",
          label: "Firma",
          type: "select",
          optionsFromResource: "companies",
          placeholder: "Firma wählen…",
        },
        { name: "content", label: "Inhalt", type: "textarea", fullWidth: true, required: true, rows: 6 },
      ]}
      columns={[
        { key: "title", label: "Titel", render: (r) => <span className="font-medium text-gray-900">{r.title}</span> },
        {
          key: "content",
          label: "Inhalt",
          render: (r) => (
            <span className="text-gray-600 line-clamp-1 max-w-md">{r.content}</span>
          ),
        },
        {
          key: "created_at",
          label: "Erstellt",
          render: (r) => new Date(r.created_at).toLocaleDateString("de-DE"),
        },
      ]}
    />
  );
}
